import React from 'react';
import axios from 'axios';
import moment from 'moment';
import {
  Alert,
  Button,
  Card,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Empty,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Statistic,
  Switch,
  Tooltip,
  message,
  Checkbox,
} from 'antd';
import { LoadingOutlined, MergeCellsOutlined, PlusCircleFilled } from '@ant-design/icons';
import CurrencyFormat from 'react-currency-format';
import * as reactstrp from 'reactstrap';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn';
import { ReportEmailControls, submitReportWithEmail, reportSearchButtonLabel, REPORT_KEYS, initialReportEmailState } from '../reportEmailUtils';
import { getDefaultJournalHealthDateRange, periodLabel } from '../journalHealthUtils';
import JounaldetailsView from './JounaldetailsView';

var CryptoJS = require('crypto-js');

const FormItem = Form.Item;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const dateFormat = 'DD/MM/YYYY';
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var sacco = '';
var bizuserid = '';
var token = '';
var username = '';

class UnbalancedJournalNumbersView extends React.Component {
  state = {
    ...initialReportEmailState(),
    dateone: '',
    datetwo: '',
    datarequested: false,
    sheetitems: [],
    selected_jnal: '',
    show_details: false,
    companyprofile: {},
    userrights: {},
    reversal_form_visible: false,
    selected_jounal: '',
    tobereversed_transactions: [],
    loan_txn_report: [],
    general_ledger_entriesreport: [],
    txn_delete_list: [],
    journals_delete_list: [],
    loan_txn_delete_list: [],
    reversal_mode: 'all_records',
    reversal_reason: '',
    searched: false,
    totalUnbalanced: 0,
    totalVariance: 0,
    combineSelected: [],
    combineModalVisible: false,
    combinePreview: null,
    combineLoading: false,
    combineTargetJournal: null,
    combineReason: '',
    userprofile: {},
  };

  componentDidMount() {
    if (localStorage.getItem('sacco')) {
      sacco = CryptoJS.AES.decrypt(localStorage.getItem('sacco'), 'my-secret-key@12345').toString(CryptoJS.enc.Utf8);
      bizuserid = CryptoJS.AES.decrypt(localStorage.getItem('bizuserid'), 'my-secret-key@1234').toString(CryptoJS.enc.Utf8);
      username = CryptoJS.AES.decrypt(localStorage.getItem('username'), 'my-secret-key@123').toString(CryptoJS.enc.Utf8);
    } else {
      sacco = '';
      bizuserid = '';
      username = '';
    }

    if (localStorage.getItem('token')) {
      token = localStorage.getItem('token');
    } else {
      token = '';
    }

    axios.defaults.headers = {
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    };

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
      .then((res) => {
        this.setState((prev) => ({
          companyprofile: res.data,
          receiving_email: prev.receiving_email || res.data.company_email || '',
        }));
        const navState = this.props.location && this.props.location.state;
        if (navState && navState.dateone && navState.datetwo) {
          this.setState(
            { dateone: navState.dateone, datetwo: navState.datetwo },
            () => this.loadReport()
          );
        } else {
          this.setState(getDefaultJournalHealthDateRange(res.data));
        }
      });

    axios.get(serverconfig.backendserverurl + `/api/accountrights/?user=${bizuserid}`)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          this.setState({ userrights: res.data[0] });
        }
      });

    if (bizuserid) {
      axios.get(`${serverconfig.backendserverurl}/api/accounts/${bizuserid}/`)
        .then((res) => {
          this.setState({ userprofile: res.data });
        })
        .catch(() => {});
    }
  }

  handledatechange = (date, dateString) => {
    this.setState({ dateone: dateString[0], datetwo: dateString[1] });
  };

  applyCurrentFyRange = () => {
    this.setState(getDefaultJournalHealthDateRange(this.state.companyprofile));
  };

  loadReport = () => {
    const form_data = new FormData();
    form_data.append('sacco', sacco);
    form_data.append('dateone', this.state.dateone);
    form_data.append('datetwo', this.state.datetwo);

    submitReportWithEmail({
      reportKey: REPORT_KEYS.UNBALANCED_JOURNAL_NUMBERS,
      params: { sacco, dateone: this.state.dateone, datetwo: this.state.datetwo },
      emailReport: this.state.email_report,
      receivingEmail: this.state.receiving_email,
      endpoint: serverconfig.backendserverurl + '/customqueries/get_unbalanced_journal_numbers',
      formData: form_data,
      setLoading: (v) => this.setState({ datarequested: v }),
      onSuccess: (res) => {
        const items = JSON.parse(res.data.report || '[]');
        const totalVariance = items.reduce((sum, row) => sum + Number(row.variance || 0), 0);
        this.setState({
          sheetitems: items,
          searched: true,
          totalUnbalanced: res.data.total_unbalanced_journals || items.length,
          totalVariance,
          combineSelected: [],
        });
        if ((res.data.total_unbalanced_journals || 0) === 0) {
          message.success('No unbalanced journals found for the selected period');
        } else {
          message.warning(`Found ${res.data.total_unbalanced_journals} unbalanced journal(s)`);
        }
      },
    });
  };

  openReversalForm = (journalNo) => {
    const form_data = new FormData();
    form_data.append('journalno', journalNo);
    form_data.append('sacco', sacco);

    axios.post(serverconfig.backendserverurl + '/customqueries/queryreversal_transactions_from_till', form_data, {
      headers: { 'content-type': 'multipart/form-data' },
    })
      .then((res) => {
        this.setState({
          selected_jounal: journalNo,
          tobereversed_transactions: JSON.parse(res.data.txn_report),
          loan_txn_report: JSON.parse(res.data.loan_txn_report),
          general_ledger_entriesreport: JSON.parse(res.data.general_ledger_entriesreport),
          txn_delete_list: [],
          loan_txn_delete_list: [],
          journals_delete_list: [],
          reversal_form_visible: true,
        });
      })
      .catch((error) => {
        message.error('Failed to load linked records for reversal');
        console.log(error);
      });
  };

  confirmReversal = () => {
    const form_data = new FormData();
    form_data.append('journal_id', this.state.selected_jounal);
    form_data.append('sacco', sacco);
    form_data.append('username', username);
    form_data.append('txn_delete_list', JSON.stringify(this.state.txn_delete_list));
    form_data.append('loan_txn_delete_list', JSON.stringify(this.state.loan_txn_delete_list));
    form_data.append('journals_delete_list', JSON.stringify(this.state.journals_delete_list));
    form_data.append('reversal_mode', this.state.reversal_mode);
    form_data.append('reversal_source', 'unbalanced_journal_checker');
    form_data.append('reversal_reason', this.state.reversal_reason);

    this.setState({ datarequested: true });
    axios.post(serverconfig.backendserverurl + '/customqueries/delete_journal', form_data, {
      headers: { 'content-type': 'multipart/form-data' },
    })
      .then((res) => {
        message.success(res.data.message || 'Reversal completed');
        this.setState({
          reversal_form_visible: false,
          reversal_reason: '',
        });
        this.loadReport();
      })
      .catch((error) => {
        this.setState({ datarequested: false });
        message.error('Reversal failed');
        console.log(error);
      });
  };

  canReverse = () => {
    return this.state.companyprofile.allow_transaction_reversal &&
      this.state.userrights.can_make_transaction_reversals;
  };

  canCombineJournals = () => this.state.userprofile && this.state.userprofile.branch_manager === true;

  toggleCombineSelection = (journalNo) => {
    const num = Number(journalNo);
    this.setState((prev) => {
      const selected = prev.combineSelected.includes(num)
        ? prev.combineSelected.filter((j) => j !== num)
        : [...prev.combineSelected, num].sort((a, b) => a - b);
      return {
        combineSelected: selected,
        combineTargetJournal: selected.length ? Math.min(...selected) : null,
      };
    });
  };

  openCombineModal = () => {
    const { combineSelected } = this.state;
    if (combineSelected.length < 2) {
      message.warning('Select at least two journal numbers to combine');
      return;
    }
    this.setState({
      combineModalVisible: true,
      combinePreview: null,
      combineReason: '',
      combineTargetJournal: Math.min(...combineSelected),
    });
    this.loadCombinePreview(combineSelected, Math.min(...combineSelected));
  };

  loadCombinePreview = (journalNumbers, targetJournal) => {
    const numbers = journalNumbers || this.state.combineSelected;
    const target = targetJournal != null ? targetJournal : this.state.combineTargetJournal;
    const form_data = new FormData();
    form_data.append('sacco', sacco);
    form_data.append('journal_numbers', JSON.stringify(numbers));
    form_data.append('target_journal_no', target);

    this.setState({ combineLoading: true });
    axios.post(
      `${serverconfig.backendserverurl}/customqueries/preview_combine_journal_numbers`,
      form_data,
      { headers: { 'content-type': 'multipart/form-data' } }
    )
      .then((res) => {
        this.setState({
          combinePreview: res.data.preview,
          combineLoading: false,
        });
      })
      .catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.message) || 'Preview failed';
        message.error(msg);
        this.setState({ combineLoading: false });
      });
  };

  confirmCombineJournals = () => {
    const { combineSelected, combineTargetJournal, combineReason } = this.state;
    const form_data = new FormData();
    form_data.append('sacco', sacco);
    form_data.append('journal_numbers', JSON.stringify(combineSelected));
    form_data.append('target_journal_no', combineTargetJournal);
    form_data.append('username', username);
    form_data.append('reason', combineReason);
    form_data.append('combine_source', 'unbalanced_journal_checker');

    this.setState({ combineLoading: true });
    axios.post(
      `${serverconfig.backendserverurl}/customqueries/combine_journal_numbers`,
      form_data,
      { headers: { 'content-type': 'multipart/form-data' } }
    )
      .then((res) => {
        message.success(res.data.message || 'Journals combined');
        this.setState({
          combineModalVisible: false,
          combineLoading: false,
          combineSelected: [],
          combinePreview: null,
        });
        this.loadReport();
      })
      .catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.message) || 'Combine failed';
        message.error(msg);
        this.setState({ combineLoading: false });
      });
  };

  renderCombineModal = () => {
    const { combinePreview, combineLoading, combineSelected, combineTargetJournal } = this.state;
    return (
      <Modal
        visible={this.state.combineModalVisible}
        title="Combine journal numbers"
        width={720}
        onCancel={() => this.setState({ combineModalVisible: false, combinePreview: null })}
        footer={[
          <Button key="cancel" onClick={() => this.setState({ combineModalVisible: false })}>
            Cancel
          </Button>,
          <Button
            key="preview"
            onClick={() => this.loadCombinePreview()}
            loading={combineLoading}
          >
            Refresh preview
          </Button>,
          <Button
            key="ok"
            type="primary"
            loading={combineLoading}
            disabled={!combinePreview}
            onClick={this.confirmCombineJournals}
          >
            Combine into one journal
          </Button>,
        ]}
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message="When to use this"
          description="Select journal numbers that belong to the same business event (e.g. both legs of a member-to-member transfer). They will share one journal ID so debits and credits balance together."
        />
        <p>
          <strong>Selected:</strong> {combineSelected.join(', ')}
        </p>
        <FormItem label="Keep as journal number (target)">
          <Select
            style={{ width: 200 }}
            value={combineTargetJournal}
            onChange={(val) => {
              this.setState({ combineTargetJournal: val });
              this.loadCombinePreview(combineSelected, val);
            }}
          >
            {combineSelected.map((jn) => (
              <Option key={jn} value={jn}>{jn}</Option>
            ))}
          </Select>
        </FormItem>
        <FormItem label="Reason (optional)">
          <Input.TextArea
            rows={2}
            value={this.state.combineReason}
            onChange={(e) => this.setState({ combineReason: e.target.value })}
            placeholder="e.g. Inter-account transfer split across two journal numbers"
          />
        </FormItem>
        {combineLoading && !combinePreview ? <Spin /> : null}
        {combinePreview ? (
          <>
            <Divider />
            <p>
              Combined GL: debit{' '}
              <CurrencyFormat value={combinePreview.combined_gl_debit} displayType="text" thousandSeparator />
              {' · '}credit{' '}
              <CurrencyFormat value={combinePreview.combined_gl_credit} displayType="text" thousandSeparator />
              {' · '}variance{' '}
              <CurrencyFormat value={combinePreview.combined_gl_variance} displayType="text" thousandSeparator />
            </p>
            <Alert
              type={combinePreview.would_balance ? 'success' : 'warning'}
              showIcon
              message={
                combinePreview.would_balance
                  ? 'After combine, this journal should balance (debits = credits).'
                  : 'After combine, GL may still be unbalanced — verify lines before confirming.'
              }
            />
            <p style={{ marginTop: 12, fontSize: 13 }}>
              Will update: {combinePreview.row_counts.general_journal} GL line(s),{' '}
              {combinePreview.row_counts.transaction} member transaction(s).
            </p>
          </>
        ) : null}
      </Modal>
    );
  };

  renderReversalModal = () => (
    <Modal
      visible={this.state.reversal_form_visible}
      title={`Reverse journal ${this.state.selected_jounal}`}
      width={1200}
      onCancel={() => this.setState({ reversal_form_visible: false })}
      footer={[
        <Button key="back" onClick={() => this.setState({ reversal_form_visible: false })}>
          Cancel
        </Button>,
        <Button key="ok" type="primary" danger onClick={this.confirmReversal}>
          Confirm reversal
        </Button>,
      ]}
    >
      <FormItem label="Reason for reversal">
        <Input.TextArea
          rows={2}
          placeholder="Reason for reversing this unbalanced journal"
          value={this.state.reversal_reason}
          onChange={(e) => this.setState({ reversal_reason: e.target.value })}
        />
      </FormItem>

      <FormItem label="Select reversal mode">
        <Select
          style={{ width: 300 }}
          value={this.state.reversal_mode}
          onChange={(val) => this.setState({ reversal_mode: val })}
        >
          <Option value="all_records">All records</Option>
          <Option value="selected_records">Selected records only</Option>
        </Select>
      </FormItem>

      <Divider />
      <Alert
        type="warning"
        showIcon
        message="All linked member statements, loan repayments, loan issues, and general journal lines for this journal number will be removed unless you choose selected records only."
      />
      <Divider />

      <h3>Member statement transactions</h3>
      <reactstrp.Table bordered>
        <thead>
          <tr>
            {this.state.reversal_mode === 'selected_records' ? <th>Add to list</th> : null}
            <th>Full names</th>
            <th>Account number</th>
            <th>Date</th>
            <th>Desc</th>
            <th>Debit</th>
            <th>Credit</th>
            <th>Journal number</th>
          </tr>
        </thead>
        <tbody>
          {this.state.tobereversed_transactions.map((item) => (
            <tr key={item.id}>
              {this.state.reversal_mode === 'selected_records' ? (
                <td>
                  <Switch
                    onChange={(val) => {
                      if (val === true) {
                        this.setState({
                          txn_delete_list: [...this.state.txn_delete_list, { key: this.state.txn_delete_list.length + 1, item: item.id }],
                        });
                      } else {
                        this.setState({
                          txn_delete_list: this.state.txn_delete_list.filter((todo) => todo.item !== item.id),
                        });
                      }
                    }}
                  />
                </td>
              ) : null}
              <td>{item.FullName}</td>
              <td>{item.AccountNumber}</td>
              <td>{item.time_stamp}</td>
              <td>{item.description}</td>
              <td><CurrencyFormat value={Number(item.debit).toFixed(2)} displayType="text" thousandSeparator /></td>
              <td><CurrencyFormat value={Number(item.credit).toFixed(2)} displayType="text" thousandSeparator /></td>
              <td>{item.journal_no}</td>
            </tr>
          ))}
        </tbody>
      </reactstrp.Table>

      <Divider />
      <h3>Loan track transactions</h3>
      <reactstrp.Table bordered>
        <thead>
          <tr>
            {this.state.reversal_mode === 'selected_records' ? <th>Add to list</th> : null}
            <th>Date</th>
            <th>Outstanding bal</th>
            <th>Payment details</th>
            <th>Journal no</th>
          </tr>
        </thead>
        <tbody>
          {this.state.loan_txn_report.map((item) => (
            <tr key={item.id}>
              {this.state.reversal_mode === 'selected_records' ? (
                <td>
                  <Switch
                    onChange={(val) => {
                      if (val === true) {
                        this.setState({
                          loan_txn_delete_list: [...this.state.loan_txn_delete_list, { key: this.state.loan_txn_delete_list.length + 1, item: item.id }],
                        });
                      } else {
                        this.setState({
                          loan_txn_delete_list: this.state.loan_txn_delete_list.filter((todo) => todo.item !== item.id),
                        });
                      }
                    }}
                  />
                </td>
              ) : null}
              <td>
                <span style={{ display: 'flex', flexDirection: 'column' }}>
                  {item.date}
                  <Link to={`/loanissues/${item.loan_reference}`}>View loan</Link>
                </span>
              </td>
              <td><CurrencyFormat value={Number(item.outstanding_bal).toFixed(2)} displayType="text" thousandSeparator /></td>
              <td>{item.description}</td>
              <td>{item.journal_no}</td>
            </tr>
          ))}
        </tbody>
      </reactstrp.Table>

      <Divider />
      <h3>General ledger transactions</h3>
      <reactstrp.Table bordered>
        <thead>
          <tr>
            {this.state.reversal_mode === 'selected_records' ? <th>Add to list</th> : null}
            <th>Date</th>
            <th>Account</th>
            <th>Desc</th>
            <th>Debit</th>
            <th>Credit</th>
            <th>Journal no</th>
          </tr>
        </thead>
        <tbody>
          {this.state.general_ledger_entriesreport.map((item) => (
            <tr key={item.id}>
              {this.state.reversal_mode === 'selected_records' ? (
                <td>
                  <Switch
                    onChange={(val) => {
                      if (val === true) {
                        this.setState({
                          journals_delete_list: [...this.state.journals_delete_list, { key: this.state.journals_delete_list.length + 1, item: item.id }],
                        });
                      } else {
                        this.setState({
                          journals_delete_list: this.state.journals_delete_list.filter((todo) => todo.item !== item.id),
                        });
                      }
                    }}
                  />
                </td>
              ) : null}
              <td>{item.date}</td>
              <td>{item.account}</td>
              <td>{item.description}</td>
              <td><CurrencyFormat value={Number(item.Debit).toFixed(2)} displayType="text" thousandSeparator /></td>
              <td><CurrencyFormat value={Number(item.Credit).toFixed(2)} displayType="text" thousandSeparator /></td>
              <td>{item.journal_no}</td>
            </tr>
          ))}
        </tbody>
      </reactstrp.Table>
    </Modal>
  );

  render() {
    const rangeValue =
      this.state.dateone && this.state.datetwo
        ? [moment(this.state.dateone, dateFormat), moment(this.state.datetwo, dateFormat)]
        : null;

    return (
      <div>
        <Card bordered={false} style={{ marginBottom: 16 }}>
          <h3 style={{ marginBottom: 4, color: '#154360', fontWeight: 700 }}>Unbalanced journals</h3>
          <p style={{ marginBottom: 0, color: '#667085' }}>
            Journal numbers where total debits do not equal total credits. Review and reverse mistaken postings before closing the period.
          </p>
        </Card>

        <Collapse defaultActiveKey={['1']}>
          <Panel header="Search unbalanced journal numbers" key="1">
            <Alert
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
              message="Tip"
              description="Use “Current FY” to scan from the day after your data entry cap through today. Expand a row to inspect individual GL lines."
            />

            <Form layout="inline">
              <FormItem label="Date range">
                <RangePicker
                  value={rangeValue}
                  onChange={this.handledatechange}
                  format={dateFormat}
                />
              </FormItem>
              <FormItem>
                <Button onClick={this.applyCurrentFyRange}>Current FY</Button>
              </FormItem>
              <ReportEmailControls
                emailReport={this.state.email_report}
                receivingEmail={this.state.receiving_email}
                onEmailReportChange={(val) => this.setState({ email_report: val })}
                onReceivingEmailChange={(val) => this.setState({ receiving_email: val })}
                companyEmail={this.state.companyprofile.company_email}
              />

              <FormItem>
                <Button
                  type="primary"
                  loading={this.state.datarequested}
                  onClick={() => {
                    if (this.state.dateone === '' || this.state.datetwo === '') {
                      message.error('Please select date range');
                    } else {
                      this.loadReport();
                    }
                  }}
                >
                  {reportSearchButtonLabel(this.state.email_report) === 'Search' ? 'Check journals' : reportSearchButtonLabel(this.state.email_report)}
                </Button>
              </FormItem>
            </Form>

            {this.state.searched && this.canCombineJournals() && this.state.sheetitems.length > 0 ? (
              <>
                <Divider />
                <Alert
                  type="info"
                  showIcon
                  style={{ marginBottom: 12 }}
                  message="Combine related journals"
                  description="Tick two or more rows that are parts of the same transfer or posting, then combine them under one journal number."
                />
                <Button
                  type="primary"
                  icon={<MergeCellsOutlined />}
                  disabled={this.state.combineSelected.length < 2}
                  onClick={this.openCombineModal}
                  style={{ marginBottom: 16 }}
                >
                  Combine selected ({this.state.combineSelected.length})
                </Button>
              </>
            ) : null}

            {this.state.searched ? (
              <>
                <Divider />
                <Row gutter={16} style={{ marginBottom: 16 }}>
                  <Col xs={24} sm={12} md={8}>
                    <Card size="small">
                      <Statistic title="Period" value={periodLabel(this.state.dateone, this.state.datetwo)} valueStyle={{ fontSize: 16 }} />
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Card size="small">
                      <Statistic
                        title="Unbalanced journals"
                        value={this.state.totalUnbalanced}
                        valueStyle={{ color: this.state.totalUnbalanced > 0 ? '#cf1322' : '#389e0d' }}
                      />
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Card size="small">
                      <Statistic
                        title="Total variance"
                        value={this.state.totalVariance}
                        precision={2}
                        valueStyle={{ color: this.state.totalVariance > 0 ? '#cf1322' : '#389e0d' }}
                      />
                    </Card>
                  </Col>
                </Row>
              </>
            ) : null}

            <Spin spinning={this.state.datarequested} indicator={antIcon}>
              {this.state.searched && this.state.sheetitems.length === 0 ? (
                <Empty description="No unbalanced journals in this period" />
              ) : (
                <reactstrp.Table bordered responsive>
                  <thead>
                    <tr>
                      {this.canCombineJournals() ? <th>Combine</th> : null}
                      <th>Details</th>
                      <th>No</th>
                      <th>Journal no</th>
                      <th>Date</th>
                      <th>Description</th>
                      <th>User</th>
                      <th>Entries</th>
                      <th>Total debit</th>
                      <th>Total credit</th>
                      <th>Variance</th>
                      {this.canReverse() ? <th>Reverse</th> : null}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.sheetitems.map((item) => (
                      <React.Fragment key={item.item_no + '_' + item.journal_no}>
                        <tr>
                          {this.canCombineJournals() ? (
                            <td>
                              <Checkbox
                                checked={this.state.combineSelected.includes(Number(item.journal_no))}
                                onChange={() => this.toggleCombineSelection(item.journal_no)}
                              />
                            </td>
                          ) : null}
                          <td>
                            <Tooltip title="View journal details" placement="top">
                              <PlusCircleFilled
                                style={{ color: 'blue' }}
                                onClick={() => {
                                  this.setState({
                                    selected_jnal: Number(item.journal_no),
                                    show_details: !(this.state.show_details && Number(this.state.selected_jnal) === Number(item.journal_no)),
                                  });
                                }}
                              />
                            </Tooltip>
                          </td>
                          <td>{item.item_no}</td>
                          <td>{item.journal_no}</td>
                          <td>{item.date}</td>
                          <td>{item.description}</td>
                          <td>{item.user}</td>
                          <td>{item.entry_count}</td>
                          <td className="align-right">
                            <CurrencyFormat value={item.total_debit} displayType="text" thousandSeparator />
                          </td>
                          <td className="align-right">
                            <CurrencyFormat value={item.total_credit} displayType="text" thousandSeparator />
                          </td>
                          <td className="align-right">
                            <CurrencyFormat value={item.variance} displayType="text" thousandSeparator />
                          </td>
                          {this.canReverse() ? (
                            <td>
                              <Button
                                type="primary"
                                danger
                                size="small"
                                onClick={() => this.openReversalForm(item.journal_no)}
                              >
                                Reverse
                              </Button>
                            </td>
                          ) : null}
                        </tr>

                        {this.state.show_details === true && Number(this.state.selected_jnal) === Number(item.journal_no) ? (
                          <tr>
                            <td colSpan={(this.canCombineJournals() ? 1 : 0) + (this.canReverse() ? 11 : 10)}>
                              <JounaldetailsView jounal_no={item.journal_no} />
                            </td>
                          </tr>
                        ) : null}
                      </React.Fragment>
                    ))}
                  </tbody>
                </reactstrp.Table>
              )}
            </Spin>
          </Panel>
        </Collapse>

        {this.renderReversalModal()}
        {this.renderCombineModal()}
      </div>
    );
  }
}

export default UnbalancedJournalNumbersView;
